/* globals $:false */

import { sprintf } from 'sprintf-js';

import tmpl_form from '../templates/param-form.dot';
import tmpl_msg from '../templates/msg.dot';
import tmpl_not_found from '../templates/not-found.dot';

/**
 * @param callbacks:
 *      - generateReport: the function called the when "Generate" button is clicked;
 *      - goBack: called when the "Back" button is clicked;
 */
var ReportDetailV = function(core, $container, callbacks) {

    var _$reportFormWrapper,
        _$fieldsContainer,
        _$reportMsgContainer,
        _$generateBtn,
        _$backBtn;

    var _showReport = function(reportM){
        _$reportFormWrapper = $(tmpl_form(reportM));

        _$fieldsContainer = $(".js-fields", _$reportFormWrapper);

        _$generateBtn = $(".js-generate-btn", _$reportFormWrapper);

        _$reportMsgContainer = $(".js-report-msg-container", _$reportFormWrapper);

        _$generateBtn.click(function(e) {
            e.preventDefault();

            callbacks.generateReport();
        });

        core.translate("reportm", _$reportFormWrapper);

        $container.html(_$reportFormWrapper);

        _addListenerToBackButton();
    };

    var  _showReportNotAvailable = function(reportName){
        var $reportNotFound = $(tmpl_not_found()),
            reportNotFoundMessage = sprintf(
                core.translateString("reportm", "reports.report-not-available"),
                reportName
            );

        $reportNotFound.find(".js-report-not-found-message").text(reportNotFoundMessage);

        $container.html($reportNotFound);

    };

    var _addListenerToBackButton = function(){
        _$backBtn = $(".js-back-btn", _$reportFormWrapper);

        _$backBtn.click(function(e) {
            e.preventDefault();

            callbacks.goBack();
        });
    };

    var _showReportMsg = function(msg, reportHasParameters, msgType, msgIcon){
        var $reportMsg = $(tmpl_msg({
                msg: msg,
                reportHasParameters:reportHasParameters,
                msgType:msgType,
                icon:msgIcon
            }));

        _$reportMsgContainer.html($reportMsg);
    };

    return {
        showReport:_showReport,
        showReportNotAvailable:_showReportNotAvailable,
        showReportGenerationErrorMsg: function(msg, reportHasParameters){
            _showReportMsg(msg, reportHasParameters, "error", "icon-exclamation-sign");
        },
        showReportGenerationSuccessMsg: function(msg, reportHasParameters){
            _showReportMsg(msg, reportHasParameters, "success", "icon-ok");
        },
        showGeneratingReportMsg: function(msg, reportHasParameters){
            _showReportMsg(msg, reportHasParameters, "info");
        },
        enableButtons:function() {
            _$backBtn.prop('disabled', false);
            _$generateBtn.prop('disabled', false);
        },
        disableButtons:function() {
            _$backBtn.prop('disabled', true);
            _$generateBtn.prop('disabled', true);
        },
        addField : function(field) {
            _$fieldsContainer.append(field.content());
        },
        addFieldAfter: function(field, afterWhom) {
            $(afterWhom.content()).after(field.content());
        }
    };
};

export default ReportDetailV;
